
const en = {
    ui: {
        interested: "Interested",
        going: 'Going',
        notNow: 'Not Now',
        permitNotifications: 'Enable Notifications',
        noFavoriteItems: "You haven't added any event to your favorites.",
        followings: 'Takip Ettiklerin',
        extraDates: '+{msg} dates',
        thisEventIsPassed: 'This event has taken place.',
        subscribe: 'Subscribe',
        subscribed: 'Subscribed',
        loadMore: 'Load more',
        myAccount: 'My Account',
        account: 'account',
        apply: 'apply',
        menu: 'Menu',
        all: 'All',
        agree: 'Agree',
        continue: 'Continue',
        pay: 'Pay',
        welcome: 'Welcome',
        or: 'or',
        payment: 'Payment',
        share: 'share',
        makePayment: 'Pay',
        helpAndSupport: 'Help & Support',
        faq: 'F.A.Q.',
        termsOfService: 'Terms of Service',
        privacyPolicy: 'Privacy Policy',
        allRightsReserved: 'All rights reserved',
        explore: 'Explore',
        details: 'details',
        saved: 'Saved',
        step: 'step',
        seeTicket: 'See ticket',
        notification: 'Notification',
        about: 'About',
        profile: 'Profile',
        hello: 'Hello',
        // search: 'Search',
        back: 'back',
        home: 'Home',
        backToHomePage: 'Back to home page',
        eventConditions: 'Event Conditions',
        // aboutEventPerformer: 'About {msg}',
        aboutEvent: "About Event",
        follow: 'Follow',
        followers: 'followers',
        following: 'Following',
        seeAll: 'See All',
        buyTicket: 'Buy Ticket',
        goToTicket: 'Go to Ticket',
        total: 'Total',
        ticket: 'Ticket',
        ticketInfo: 'Ticket info',
        search: 'Search',
        noEventWithSelectedSubTypes: "Sorry, we couldn't find any upcoming {msg} event",
        ok: 'OK',
        toContinue: "To continue",
        serviceFeeExplanation: "This helps us continue providing you our services.",
        studentTicketTooltip: 'You will be asked to show your student identity before enter the event venue.',
        /* TOOD revision */checkYourPurchaseWarning: 'Please, check the ticket information and be sure to read event conditions',
        eventInfo: "Event Information",
        customerInfo: "Customer Information",
        paymentInfo: 'Payment Information',
        phoneNumberOptional: "This field is optional. However, if you want to get your ticket information as SMS you need to provide your phone number",
        cardNumber: 'Card Number',
        cardExpirationDate: 'Expiration Date',
        whatIsCVC2: 'what is CVC2?',
        eventName: 'Event Name',
        eventDate: 'Event Date',
        eventLocation: 'Event Location',
        selectedTickets: 'Selected Tickets',
        fullNameOnCard: 'Full Name on Card',
        fullNameOnCardIsNotValid: 'Card holder name is not valid',
        cardNumberIsNotValid: 'Card number is not valid',
        cardExpDateIsNotValid: 'Expiration date is not valid',
        cardCVC2IsNotValid: 'CVC2 number is not valid',
        fieldCantBeEmpty: "This field can't be empty",
        checkInfoOnField: 'Check the information on this field',
        canMakePaymentByUsingBelowCards: "You can make payment by using any of the cards listed below",
        paymentLastStepIntroInfo: "You're on the last step. You can buy your ticket by entering necessary information into below fields",
        eventRules: 'Event Rules',
        reviewEventRules: 'Review event rules',
        explainWhyAndHowWeUseCustomerInformation: "We use your information to send you the tickets and to let you know about latest news of event.",
        explainHowCardInfoIsUsed: 'Your card info is only used for payment and never stored.',
        today: 'Today',
        tomorrow: 'Tomorrow',
        thisWeek: 'Bu hafta',
        thisWeekend: 'This Weekend',
        weekend: 'Weekend',
        thisMonth: 'Bu ay',
        youMightBeInterested: 'You may be interested in',
        typeYouMightBeInterested: '{msg} events you may be interested in',
        festivalsInCity: 'Festivals in {msg}',
        otherEventsOfVenue: 'Events by {msg}',
        moreFrom: 'MORE FROM',
        readMore: 'read more',
        // startsFrom: "from {msg} ₺",
        more: 'more',
        showtimes: 'Show Times',
        selectDate: 'Select Date',
        selectTicket: 'Select Ticket',
        avaliableSeats: 'avaliable seats',
        avaliableTickets: 'tickets left',
        displayDates: 'Display Dates',
        displayEvents: 'Display Events',
        seeEvents: 'See events',
        events: 'Events',
        // ofEvents: 'events',
        event: 'event',
        venues: 'Venues',
        showMap: 'See on map',
        hideMap: 'Hide map',
        hide: 'Hide',
        every: 'every',
        day: 'day',
        // date: 'tarih',
        week: 'week',
        month: 'month',
        tickets: 'Tickets',
        eventVenue: "Event Venue",
        place: 'Place',
        exploreEventsInYourCity: 'Explore events in your city',
        venueProperties: 'Venue Properties',
        ticketProvider: 'Ticket provider',
        // events: 'events',
        eventsBySameVenue: 'Events by {msg}',
        eventsByTypeNotFound: "Sorry, there is no event of type you searched.",
        seeAllEventsOfType: 'See all {msg} events',
        continueToExplore: 'Back to explore',
        willBeRedirect: 'You will be redirected to {msg} to buy ticket.',
        cancel: 'Cancel',
        ofEvents: 'events',
        ofTickets: 'tickets',
        upcoming: 'upcoming',
        upcomingEvents: 'Upcoming events',
        noUpcomingEvents: 'There is no upcoming events.',
        exploreApp: "Explore hafta8",
        featured: 'Featured',
        featuredEvents: 'Featured events',
        recommendedVenues: 'Recommended {msg} for you',
        free: 'Free',
        venueInfos: 'Venue info',
        legalName: 'Legal name',
        edit: 'edit',
        filter: 'filter',
        clear: 'clear',
        clearFilters: 'reset filters',
        filters: 'filters',
        type: 'type',
        price: 'price',
        date: 'date',
        dateRange: 'date range',
        priceRange: 'price range',
        save: 'save',
        refresh: 'refresh',
        ticketsAreSoldOnDoor: 'Tickets sold on entrance',
        favorites: 'Favorites',
        relatedVenues: 'Related venues',
        searchPlaceholder: 'Search in events and places...',
        createEvent: 'Create Event',
        addEvent: 'Add Event',
        // type: 'type',
        cookieAlert: 'We use cookies to give you the best possible experience. By using this site you accept usage of cookies.',
        iSee: 'I see',
    },
    venueType: {
        hotel: 'hotel',
        museum: 'museum',
        charity: 'charity',
        exhibitionCenter: 'exhibition center',
        artCenter: 'art center',
        performanceHall: 'performance hall',
        danceStudio: 'dance studio',
        theatre: 'theater',
        atelier: 'atelier',
        cafe: 'café',
        pub: 'pub',
        generalPurposeCenter: 'general purpose center',

    },
    venueTypePlural: {
        hotel: 'hotels',
        exhibitionCenter: 'exhibition centers',
        artCenter: 'art centers',
        performanceHall: 'performance halls',
        danceStudio: 'dance studios',
        theatre: 'theatre halls',
        atelier: 'ateliers',
        cafe: 'cafés',
        pub: 'pubs',
        generalPurposeCenter: 'general purpose centers',

    },
    venueProperties: {
        toilet: 'toilet',
        garden: 'garden',
        cloakroom: 'cloakroom',
        drink: 'drink',
        food: 'food',
        alcohol: 'alcohol',
        vale: 'vale',
        parking: 'parking',
        smokingArea: 'smoking area',
        airConditioner: 'air conditioner',
    },
    ticket: {
        selectSeat: 'Select seat',
        chooseTicket: 'Choose Ticket',
        main: 'Normal Ticket',
        adult: 'Adult',
        student: 'Student',
        discounted: 'Discounted',
        youWontBeChargedYet: "You won't be charged yet",
        serviceFee: 'Service Fee',
        startsFrom: "Starts from {msg} ₺",
        selectTicketBeforeContinue: 'Select ticket before continue',
        paymentLastStepIntroInfo: "You're on the last step. You can buy your ticket by entering necessary informations into below fields",
    },
    evType: {
        all: 'all',
        more: 'more',
        moreToCome: 'more to come',
        concert: 'Concert',
        concerts: 'concerts',
        jazz: "jazz",
        rock: "rock",
        hipHop: "hip-hop",
        indie: "indie",
        pop: "pop",
        folk: 'folk',
        turkishFolk: 'turkish folk',
        popRock: "pop-rock",
        ethnic: 'ethnic',
        dj: 'dj',
        choir: 'choir',
        alternative: "alternative",
        electronic: 'electronic',
        metal: "metal",
        symphony: "symphony",
        classical: "classical",
        concerto: 'concerto',
        rap: "rap",
        recital: 'recital',
        eighties: "80's" ,
        nineties: "90's" ,
        techno: 'techno',
        //theatre
        theatre: 'Theater',
        theaters: 'theaters',
        improvisation: 'improvisation',
        musical: 'musical',
        tragedy: 'tragedy',
        drama: "drama",
        comedy: "comedy",
        biography: "biography",
        privateTheatre: 'private theatre',
        stateTheatre: 'state theatre',
        kidsTheatre: 'kids theatre',
        //sport
        sport: 'Sport',
        football: "football",
        basketball: "basketball",
        tennis: "tennis",
        volleyball: "volleyball",
        // atelier
        atelier: 'Atelier',
        ateliers: 'ateliers',
        painting: 'painting',
        dance: 'dance',
        cooking: 'cooking',
        sculpture: 'sculpture',
        ceramic: 'seramik',
        yoga: 'yoga',
        seminar: 'seminar',
        mindfulness: 'mindfulness',
        science: 'science',
        personalDevelopment: 'personal development',
        meditation: 'meditation',
        // exhibition
        exhibition: 'Exhibition',
        exhibitions: 'exhibitions',
        digital: 'digital',
        photo: 'fotoğraf',
        // festival
        festival: 'Festival',
        festivals: 'festivals',
        art: 'art',
        coffee: 'coffee',
        music: 'music',
        film: 'film',
        foodAndDrink: 'food & drink',
        // stage
        stage: 'Stage',
        stages: "stage performances",
        standUp: 'stand-up',
        show: 'show',
        balletDance: 'ballet - dance',
        opera: 'opera',
        // party
        party: 'Party',
         // congress
         congress: 'Congress',
         congresss: 'Congress',
         conference: 'conference',
         symposium: 'symposium',
    },
    dayNames: {
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
        0: 'Sunday'
    },
    monthNames: {
        0: "January",
        1: "February",
        2: "March",
        3: "April",
        4: "May",
        5: "June",
        6: "July",
        7: "August",
        8: "September",
        9: "October",
        10: "November",
        11: "December"
    },
    profile: {
        personalInfo: 'Personal info',
        accountSettings: 'Account settings'
    },
    auth: {
        logIn: 'Log in',
        signUp: 'Sign up',
        logOut: 'Log out',
        resetPassword: 'Reset Password',
        resetPasswordExplanation: 'We send you an email with a link to reset your password',
        sendResetLink: 'Send reset link',
        sendResetLinkSuccess: 'Reset password link is sent to your email. By clicking the link you can create a new password',
        forgotPassword: 'Forgot password?',
        dontHaveAccount: "Don't have {msg} account?",
        doYouHaveAccount: 'Already have an account?',
        signInWithGoogle: 'Log in with Google',
        signUpWithGoogle: 'Sign up with Google',
        signInWithFacebook: 'Log in with Facebook',
        signUpWithFacebook: 'Sign up with Facebook',
        loginWithMail: 'Log in with Email',
        signUpWithEmail: 'Sign up with Email',
        bySubmittingYouAccept: 'By submitting this form you accept', // TODO
        email: 'Email',
        enterYourEmail: 'Enter your email',
        invalidEmail: 'Email address is invalid',
        password: 'Password',
        enterYourPassword: 'Enter your password',
        username: 'Username',
        firstName: 'first name',
        lastName: 'last name',
        fullName: 'Full Name',
        phoneNumber: 'Phone Number',
        invalidPhoneNumber: 'Invalid phone number',
        enterYourUsername: 'Enter your username',
        rememberMe: 'Remember me',
        createAccount: 'Create Account',
        showPassword: 'Show Password',
        hidePassword: 'Hide Password',
        createYourAccount: 'Create your {msg} account',
        continueWithoutSignUp: 'Continue without membership',
        acceptSiteConditions: "I acknowladge and that I've read and accept Terms and Conditions, Privacy Policy.",
        acceptInfoAndCampaigns: "I give the permission stated here to recieve campaign and other informations by email and/or SMS.",
        createUserName: 'Create username',
        createUserNameToUseInApplication: 'Create a username to use in application.',
        saveUsername: 'Save username',
        createAccountAndNeverMissAnEvent: 'Create {msg} account and never miss an event in your city.',
        enterYourRealName: 'This is the name which will appear on tickets you buy and invoices you will get.'
    }
}

export default en